<template>
  <div
    :class="['collectionController', { isActive: isActive }]"
    @mouseenter="showController"
    @mouseleave="hideController"
  >
    <div class="collectionControllerInner">
      <button type="button" class="btn btnWhite btnRound sizeXs" @click="fullScreen">전체화면 ON</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionController',
  props: [
    'locale',
    'lang'
  ],
  data () {
    return {
      isActive: false,
      hideTimer: null
    }
  },
  methods: {
    fullScreen () {
      this.$emit('fullScreen')
    },
    showController () {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      this.isActive = true
    },
    hideController () {
      if (this.hideTimer) clearTimeout(this.hideTimer)

      this.hideTimer = setTimeout(() => {
        this.isActive = false
      }, 120)
    }
  },
  beforeDestroy () {
    if (this.hideTimer) clearTimeout(this.hideTimer)
  }
}
</script>